import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SidebarTenant from "../scenes/tenant-global/SidebarTenant";
import TopbarOfTenant from "../scenes/tenant-global/TopbarTenant";

const DRAWER_WIDTH = 300;

export default function TenantLayout({ children, contentSx = {} }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        bgcolor: "background.default",
      }}
    >
      <SidebarTenant
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        variant={isDesktop ? "persistent" : "temporary"}
        drawerWidth={DRAWER_WIDTH}
      />

      <Box
        sx={{
          flexGrow: 1,
          ml: isDesktop && menuOpen ? `${DRAWER_WIDTH}px` : 0,
          transition: "margin 0.3s ease",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <TopbarOfTenant menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: "100%",
            px: { xs: 2, md: 4, lg: 6 },
            py: { xs: 4, md: 6 },
            bgcolor: "background.default",
            ...contentSx,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
